<template >
<tr>
    <th class="sheet-header text-truncate text-capitalize" style="border-left: 2px solid white">
        <v-row class="flex-nowrap " align="center" no-gutters>
            <v-btn class="mr-1" icon x-small @click="$emit('display')">
                <v-icon small>mdi-chevron-down</v-icon>
            </v-btn>
            <v-col class="text-truncate">
                {{rate_plan.name}}
            </v-col>
        </v-row>
    </th>
    <template v-for="day in prices">
        <td :class="['sheet-cell text-center',readonly?'pa-0':'']">
            <v-progress-circular v-if="loading_date == day.date" size="12" width="2" indeterminate />
            <input v-else v-model.lazy="day.price" class="sheet-input" type="number" @change="save(day)" :style="readonly?'background-color: transparent; outline-color: transparent':''" :readonly="readonly" />
        </td>
    </template>
</tr>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        rate_plan: Object,
        params: Object,
        backup_sheet: [Object, Array],
        prices: Object,
        admin: Boolean,
        context: String,
    },
    components: {},
    data() {
        return {
            loading_date: null,
        }
    },

    computed: {
        readonly() {
            let value = (this.context !== 'imemento') || (!!this.rate_plan.parent_id) || this.rate_plan.component_based || (!this.admin && (this.rate_plan.net_prices == true))
            return value
        }
    },
    mounted() {},

    watch: {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

        save(day) {
            this.loading_date = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                price: day.price
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].price = day.price;
                })
                .catch(error => {
                    this.prices[day.date].price = this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].price;
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date = null;
                });
        },
    }
}
</script>
